import React from 'react';
import './AirtimeRewards.css';

const AirtimeRewardsPage = () => {
  return (
    <div className="airtime-rewards-page">

      {/* Hero Section */}
      <section className="hero-section">
        <div className="container">
          <h1 className="hero-title">Bulk Airtime</h1>
          <p className="hero-subtitle">
          From surveys to sales, referrals to repeat visits — our platform lets you disburse airtime to anyone, anytime, anywhere in Kenya.
          </p>
        </div>
      </section>

      {/* Rewards Feature Section */}
      <section className="rewards-feature-section">
        <div className="container">
          <div className="rewards-feature-content">
            <div className="rewards-image">
              <img src="/images/airtime.jpg" alt="Mobile phone showing airtime reward app" />
            </div>
            <div className="rewards-text">
              <h2 className="rewards-title">
                Reward Your Customers With What They Really Want —<br />
                Instant Airtime.
              </h2>
              <p className="rewards-description">
                We help businesses, brands, and organizations instantly reward users, customers, or staff with airtime across all mobile networks.
              </p>
              <p className="rewards-description">
                Perfect for promotions, loyalty programs, feedback campaigns, and more.
              </p>

              <a
                href="https://app.peakmobile.co.ke/signin" 
                target="_blank"
                rel="noopener noreferrer">
                  
                <button className="sign-up-button">Get Started →</button>

              </a>

            </div>
          </div>
        </div>
      </section>

      {/* Platform Section */}
      <section className="platform-section">
        <div className="container">
          <h2 className="section-title">Key Platform Features</h2>
          
          <div className="features-grid">
            {/* Feature 1 */}
            <div className="feature-card">
              <div className="feature-image">
                <img src="/images/instant-airtime.jpg" alt="Instant Airtime Delivery" />
              </div>
              <h3 className="feature-title">Instant Airtime Delivery</h3>
              <p className="feature-description">In Real-time, across all networks</p>
            </div>

            {/* Feature 2 */}
            <div className="feature-card">
              <div className="feature-image">
                <img src="/images/campaigns.jpg" alt="Customized Campaigns" />
              </div>
              <h3 className="feature-title">Customised Campaigns</h3>
              <p className="feature-description">Run & Schedule campaigns</p>
            </div>

            {/* Feature 3 */}
            <div className="feature-card">
              <div className="feature-image">
                <img src="/images/api.jpg" alt="Available APIs" />
              </div>
              <h3 className="feature-title">Available APIs</h3>
              <p className="feature-description">Plug airtime reward triggers directly into your existing platforms, CRMs, ecommerce, etc.</p>
            </div>

            {/* Feature 4 */}
            <div className="feature-card">
              <div className="feature-image">
                <img src="/images/scale.jpg" alt="Works at Scale" />
              </div>
              <h3 className="feature-title">Works at Scale</h3>
              <p className="feature-description">We help businesses to reward to thousands in a few seconds. Or one at a time.</p>
            </div>

            {/* Feature 5 */}
            <div className="feature-card">
              <div className="feature-image">
                <img src="/images/dashboard.jpg" alt="Dashboard Control" />
              </div>
              <h3 className="feature-title">Dashboard Control</h3>
              <p className="feature-description">Get real time insights on campaign performance.</p>
            </div>

            {/* Feature 6 */}
            <div className="feature-card">
              <div className="feature-image">
                <img src="/images/affordable.jpg" alt="Affordable & Flexible" />
              </div>
              <h3 className="feature-title">Affordable & Flexible</h3>
              <p className="feature-description">Every Airtime transaction attracts a discount</p>
            </div>
          </div>
        </div>
      </section>

      {/* Industry Use Cases Section */}
      <section className="industry-cases-section" id="industry-cases-section">
        <div className="container">
          <h2 className="section-title">Industry Use Cases</h2>
          
          <div className="cases-grid">
            {/* Case 1 */}
            <div className="case-card">
              <h3 className="case-title">E-commerce Platforms</h3>
              <p className="case-description">Boost first-time purchases or referrals</p>
            </div>

            {/* Case 2 */}
            <div className="case-card">
              <h3 className="case-title">Banks & Fintechs</h3>
              <p className="case-description">Reward account openings or app sign-ups</p>
            </div>

            {/* Case 3 */}
            <div className="case-card">
              <h3 className="case-title">Research & Survey Firms</h3>
              <p className="case-description">Thank respondents with instant airtime</p>
            </div>

            {/* Case 4 */}
            <div className="case-card">
              <h3 className="case-title">Marketing Agencies</h3>
              <p className="case-description">Run brand activations that convert</p>
            </div>

            {/* Case 5 */}
            <div className="case-card">
              <h3 className="case-title">Saccos & Insurance</h3>
              <p className="case-description">Incentivize payments, renewals, or sign-ups</p>
            </div>

            {/* Case 6 */}
            <div className="case-card">
              <h3 className="case-title">Startups & Apps</h3>
              <p className="case-description">Reward milestones like onboarding or reviews</p>
            </div>
          </div>
        </div>
      </section>

      {/* Smart Ways Section */}
      <section className="smart-ways-section">
        <div className="container">
          <h2 className="section-title">Smart Ways to Use Airtime Rewards</h2>
          
          <div className="ways-grid">
            {/* Way 1 */}
            <div className="way-card">
              <div className="way-icon">
                <img src="/images/icons/refer.svg" alt="Refer a Friend" />
              </div>
              <p className="way-description">Refer a Friend, Earn Airtime</p>
            </div>

            {/* Way 2 */}
            <div className="way-card">
              <div className="way-icon">
                <img src="/images/icons/topup.svg" alt="Tip Jar" />
              </div>
              <p className="way-description">Top-Up for Every 5 Transactions</p>
            </div>

            {/* Way 3 */}
            <div className="way-card">
              <div className="way-icon">
                <img src="/images/icons/reward.svg" alt="Birthday" />
              </div>
              <p className="way-description">Reward Users on Their Birthday</p>
            </div>

            {/* Way 4 */}
            <div className="way-card">
              <div className="way-icon">
                <img src="/images/icons/win.svg" alt="Lucky Draw" />
              </div>
              <p className="way-description">Win Airtime in a Lucky Draw</p>
            </div>

            {/* Way 5 */}
            <div className="way-card">
              <div className="way-icon">
                <img src="/images/icons/signup.svg" alt="Signing Up" />
              </div>
              <p className="way-description">Get Airtime After Signing Up or Downloading an App</p>
            </div>

            {/* Way 6 */}
            <div className="way-card">
              <div className="way-icon">
                <img src="/images/icons/reactive.svg" alt="Inactive Customers" />
              </div>
              <p className="way-description">Reactivate Inactive Customers with a Surprise</p>
            </div>
          </div>
        </div>
      </section>

    
    </div>
  );
};

export default AirtimeRewardsPage;